import React from 'react'
import { DataTable } from '../../comp/DataTableV2'
import {
    listarUsuarios,
    borrarUsuarios,
    reactivarUsuarios
} from '../../services/servUsuarios'
import { ModalDelete } from '../../comp/ModalDelete'
import { Acciones } from '../../utils/Acciones'
import { TipoDato } from '../../utils/Constantes'
import { Detalle, Filtros } from './contenido'
import { Messages } from '../../comp/Messages2'
import { FormatNombreUsuario } from '../../utils/Formatter'

export const Usuarios = () => {

    const tableConfig = React.useMemo(() => ({
        title: 'ViewUsuarios',
        headers: ['TXT_APELLIDOS', 'TXT_NOMBRES', 'TXT_CORREO', 'TXT_ROLES'],
        types: [TipoDato.CADENA, TipoDato.CADENA, TipoDato.CADENA, TipoDato.CADENA],
        access: ['apellidos', 'nombres', 'email', 'rolesStr'],
        rowId: 'id'
    }), [])

    const [detailAction, setDetailAction] = React.useState(Acciones.SEE)
    const [isDelReacOpened, setIsDelReacOpened] = React.useState(false)
    const [isDetailOpened, setIsDetailOpened] = React.useState(false)
    const [isSearchOpened, setIsSearchOpened] = React.useState(false)

    const [isTableLoading, setIsTableLoading] = React.useState(false)
    const [tableData, setTableData] = React.useState([])
    const [tableSelection, setTableSelection] = React.useState([])
    const [tableFilters, setTableFilters] = React.useState({ activo: true })

    const [resServicio, setResServicio] = React.useState()

    const handleOpenDetail = (action, selection) => {
        setDetailAction(action)
        if (selection) {
            setTableSelection(tableData.filter(e => (selection.length && selection.indexOf(e.id) > -1) || e.id === selection))
        } else {
            setTableSelection([])
        }
        ([Acciones().DEL, Acciones().REAC]).includes(action)
            ? setIsDelReacOpened(true)
            : setIsDetailOpened(true)
    }

    const handleSearchSubmit = (submit, filters) => {
        setIsSearchOpened(false)
        submit
            && setTableFilters(filters)
    }

    const handleDetailSubmit = (obj) => {
        setIsDetailOpened(false)
        setTableSelection([])
        //si viene un objeto
        if (obj) {
            formatDataForTable([obj])
            if (detailAction === Acciones().ADD)
                setTableData([obj]) //si es alta: lo dejo solo en la tabla
            else
                setTableData(tableData.map(e => { return e.id === obj.id ? obj : e })) //sino edito
        }
    }

    const handleDelReacSubmit = async (submit) => {
        if (!submit) return setIsDelReacOpened(false)
        let resOp = (detailAction === Acciones().DEL)
            ? await borrarUsuarios(tableSelection.map(e => e.id))
            : await reactivarUsuarios(tableSelection.map(e => e.id))
        setResServicio(resOp)
        if (!resOp.errores) {
            setTableData(tableData.map(e =>
                tableSelection.some(sel => sel.id === e.id)
                    ? { ...e, activo: detailAction === Acciones().REAC }
                    : e
            ))
            setIsDelReacOpened(false)
            setTableSelection([])
        }
    }

    const formatDataForTable = (datos) => {
        datos.forEach(d => {
            d.rolesStr = d.roles.map(r => r.nombre).join(', ')
        })
        return //agregar funcionalidad si hace falta
    }

    React.useEffect(() => {
        setIsTableLoading(true)
        setResServicio()
        listarUsuarios({ ...tableFilters, incluirRoles: true }).then(res => {
            res.errores
                ? setResServicio(res)
                : formatDataForTable(res.data)
            setTableData(res.data)
            setIsTableLoading(false)
        })
    }, [tableFilters])

    return <>
        <DataTable title={tableConfig.title}
            headers={tableConfig.headers}
            types={tableConfig.types}
            access={tableConfig.access}
            rowId={tableConfig.rowId}
            data={tableData}
            isLoading={isTableLoading}
            openDetail={handleOpenDetail}
            openSearch={setIsSearchOpened}
            hasAdd hasEdit hasReac hasDel />
        <Filtros isOpen={isSearchOpened}
            onSubmit={handleSearchSubmit}
            filtros={tableFilters} />
        <Detalle accion={detailAction}
            isOpen={isDetailOpened}
            onSubmit={handleDetailSubmit}
            seleccion={tableSelection[0]} />
        <ModalDelete isOpen={isDelReacOpened}
            seleccion={tableSelection.map(e => FormatNombreUsuario(e))}
            action={detailAction}
            onSubmit={handleDelReacSubmit} />
        <Messages resServicio={resServicio} accion={detailAction} />
    </>
}